import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'react-oidc-context';
import { RouterProvider } from 'react-router';
import { initSentry } from '@src/bootstrap/sentry.init';
import '@src/i18n';
import '@src/index.css';
import { userManager } from '@src/auth/oidcConfig';
import { browserRouter } from '@src/routes/routes';
import { queryClient } from '@src/api/queryClient';
import { CmpProvider } from '@src/bootstrap/cmp/CmpProvider.tsx';
import { SentryApp } from './bootstrap/SentryApp';
import { isConsentGiven } from './bootstrap/cmp/utils';

initSentry(isConsentGiven());

const rootElement = document.getElementById('root')!;

const root = createRoot(rootElement, {
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <CmpProvider>
      <SentryApp>
        <QueryClientProvider client={queryClient}>
          {/* Pass the instance, not the config: spreading the config makes
              react-oidc-context build its own UserManager, so the app would run
              two independent silent-renew timers over one storage key. */}
          <AuthProvider userManager={userManager}>
            <RouterProvider router={browserRouter} />
          </AuthProvider>
        </QueryClientProvider>
      </SentryApp>
    </CmpProvider>
  </StrictMode>,
);
